
import React from 'react';
import { Sparkles } from 'lucide-react';

interface MentalWellnessInsightProps {
  insight: {
    title: string;
    description: string;
    recommendations: string[];
  };
}

const MentalWellnessInsight: React.FC<MentalWellnessInsightProps> = ({ insight }) => {
  return (
    <div className="mb-4 p-4 border border-muted rounded-lg">
      <h3 className="text-lg font-medium mb-2">{insight.title}</h3>
      <p className="text-sm text-muted-foreground mb-4">{insight.description}</p>
      <div>
        <h4 className="text-sm font-medium mb-1">AI Recommendations:</h4>
        <ul className="space-y-1">
          {insight.recommendations.map((rec, idx) => (
            <li key={idx} className="text-sm flex items-start gap-2">
              <Sparkles className="h-4 w-4 text-indigo-400 mt-0.5 flex-shrink-0" />
              {rec}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MentalWellnessInsight;
